import React, { useContext, useState } from "react";

import { toast } from "react-toastify";

import { NoteState } from "../../../context/notes/NoteState";

import { emptyMealOption } from "./mealPlanIntakeFormData";
import { displayMealImageSrc } from "./mealPlanImageResolve";

import NutritionMediaPicker from "../../Nutrition/NutritionMediaPicker";



const ACCEPTED_TYPES = /^image\/(jpeg|jpg|png|gif|webp)$/i;



export default function MealPlanOptionEditor({

  optionNumber,

  value,

  onChange,

  readOnly = false,

  onRemove,

  canRemove = false,

  branchId,

}) {

  const { state } = useContext(NoteState);

  const effectiveBranchId = branchId || state?.branch_id;

  const opt = value || emptyMealOption();

  const preview = displayMealImageSrc(opt.imagePreview || opt.imageUrl);

  const [showGallery, setShowGallery] = useState(false);



  const handleText = (text) => onChange({ ...opt, text });



  const handleFile = (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    if (!ACCEPTED_TYPES.test(file.type)) {

      toast.error("Please upload JPG, PNG, GIF, or WEBP only");

      e.target.value = "";

      return;

    }

    if (file.size > 5 * 1024 * 1024) {

      toast.error("Image must be 5MB or smaller");

      e.target.value = "";

      return;

    }

    if (opt.imagePreview) URL.revokeObjectURL(opt.imagePreview);

    onChange({

      ...opt,

      imageFile: file,

      imagePreview: URL.createObjectURL(file),

      imageUrl: null,

    });

    e.target.value = "";

  };



  const handleGallerySelect = ({ imageUrl }) => {

    if (opt.imagePreview) URL.revokeObjectURL(opt.imagePreview);

    onChange({

      ...opt,

      imageFile: null,

      imagePreview: null,

      imageUrl,

    });

    setShowGallery(false);

  };



  const removeImage = () => {

    if (opt.imagePreview) URL.revokeObjectURL(opt.imagePreview);

    onChange({

      ...opt,

      imageFile: null,

      imagePreview: null,

      imageUrl: null,

    });

  };



  return (

    <div className="mpi-option-editor border rounded p-3 mb-3">

      <div className="d-flex align-items-center justify-content-between mb-2">

        <div className="fw-semibold">Option {optionNumber}</div>

        {!readOnly && canRemove && onRemove ? (

          <button

            type="button"

            className="btn btn-sm btn-outline-danger mpi-editor-only"

            title="Remove option"

            onClick={onRemove}

          >

            <i className="bi bi-x-lg" />

          </button>

        ) : null}

      </div>

      <div className="row g-3">

        <div className="col-md-7">

          <textarea

            className="form-control"

            rows={5}

            value={opt.text}

            readOnly={readOnly}

            placeholder="Meal description, ingredients, portions..."

            onChange={(e) => handleText(e.target.value)}

          />

        </div>

        <div className="col-md-5">

          {!readOnly ? (

            <div className="d-grid gap-2 mb-2">

              <button

                type="button"

                className="btn btn-sm btn-outline-primary"

                onClick={() => {

                  if (!effectiveBranchId) {

                    toast.error("Please select a branch first");

                    return;

                  }

                  setShowGallery(true);

                }}

              >

                <i className="bi bi-images me-1" />

                Choose from gallery

              </button>

              <label className="btn btn-sm btn-outline-secondary mb-0">

                <i className="bi bi-upload me-1" />

                Upload from computer

                <input

                  type="file"

                  className="d-none"

                  accept="image/jpeg,image/png,image/gif,image/webp"

                  onChange={handleFile}

                />

              </label>

            </div>

          ) : null}

          {preview ? (

            <div className="mpi-option-preview">

              <img src={preview} alt={`Option ${optionNumber}`} />

              {!readOnly ? (

                <button type="button" className="btn btn-sm btn-danger mt-1" onClick={removeImage}>

                  Remove photo

                </button>

              ) : null}

            </div>

          ) : (

            <div className="mpi-option-preview mpi-option-preview--empty">No photo</div>

          )}

        </div>

      </div>



      <NutritionMediaPicker

          show={showGallery}

          onHide={() => setShowGallery(false)}

          branchId={effectiveBranchId}

          onSelect={handleGallerySelect}

          title={`Select image — Option ${optionNumber}`}

        />

    </div>

  );

}



export function MealOptionPrintRow({ optionNumber, option }) {
  const preview = displayMealImageSrc(option?.imagePreview || option?.imageUrl);
  const lines = String(option?.text || "")
    .replace(/\r\n/g, "\n")
    .trim()
    .split("\n")
    .map((line) => line.trimEnd())
    .filter((line) => line.trim() !== "");

  return (
    <tr>
      <td className="mpi-option-text">
        <strong>Option {optionNumber}</strong>
        <div className="mpi-option-text-body">
          {lines.length
            ? lines.map((line, i) => <p key={i}>{line}</p>)
            : preview
              ? null
              : <p>&nbsp;</p>}
        </div>
      </td>
      <td className="mpi-option-image">
        {preview ? (
          <img src={preview} alt={`Option ${optionNumber}`} crossOrigin="anonymous" />
        ) : (
          <span>&nbsp;</span>
        )}
      </td>
    </tr>
  );
}



export function MealOptionsPrintTable({ options, startNumber = 1 }) {

  return (

    <table className="mpi-table mpi-options-table">

      <tbody>

        {options.map((opt, idx) => (

          <MealOptionPrintRow

            key={idx}

            optionNumber={startNumber + idx}

            option={opt}

          />

        ))}

      </tbody>

    </table>

  );

}


